import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="relative">
        <div className="absolute -inset-1 bg-gradient-to-r from-primary to-accent rounded-lg blur-lg opacity-25"></div>
        <div className="glass-card p-8 sm:p-12 max-w-md text-center relative">
          <div className="relative mb-8">
            <h1 className="text-8xl font-bold bg-gradient-to-r from-primary to-accent text-transparent bg-clip-text">
              404
            </h1>
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center opacity-10">
              {Array.from({ length: 20 }).map((_, i) => (
                <div 
                  key={i}
                  className="absolute w-16 h-16 border border-primary/30 rounded-full"
                  style={{ 
                    animation: `pulse 3s cubic-bezier(0.4, 0, 0.6, 1) infinite ${i * 0.1}s`,
                    opacity: 1 - i * 0.05,
                    transform: `scale(${i * 0.1 + 1})` 
                  }}
                />
              ))}
            </div>
          </div>
          
          <h2 className="text-2xl font-semibold mb-4">Page Not Found</h2>
          <p className="text-text/70 mb-8">
            The financial data you're looking for seems to have been invested elsewhere. Let's get you back on track.
          </p>
          
          <div className="space-y-3">
            <Link to="/">
              <Button fullWidth>
                Return to Home
              </Button>
            </Link>
            
            <Link to="/dashboard">
              <Button variant="outline" fullWidth>
                Go to Dashboard
              </Button>
            </Link>
          </div>
        </div>
      </div>
      
      {/* Animated elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent/10 rounded-full blur-3xl"></div>
        
        {/* Digital particles */}
        <div className="absolute inset-0" aria-hidden="true">
          {Array.from({ length: 20 }).map((_, i) => (
            <div 
              key={i}
              className="absolute bg-primary/30 rounded-full w-1 h-1"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animation: `float ${3 + Math.random() * 5}s ease-in-out infinite`
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotFound; 